/** Date range presets used by FiltersBar. */

import { format } from "date-fns";

export type PresetKey = "today" | "week" | "month" | "quarter" | "year" | "custom";

export const PRESETS: { key: PresetKey; label: string }[] = [
  { key: "today", label: "Hôm nay" },
  { key: "week", label: "7 ngày" },
  { key: "month", label: "Tháng" },
  { key: "quarter", label: "Quý" },
  { key: "year", label: "Năm" },
  { key: "custom", label: "Tuỳ chọn" },
];

function ymd(d: Date) {
  return format(d, "yyyy-MM-dd");
}

export function presetRange(key: PresetKey, today = new Date()): { from: string; to: string } {
  const to = ymd(today);
  const start = new Date(today);
  if (key === "today") return { from: to, to };
  if (key === "week") {
    start.setDate(start.getDate() - 6);
    return { from: ymd(start), to };
  }
  if (key === "month") {
    start.setDate(1);
    return { from: ymd(start), to };
  }
  if (key === "quarter") {
    const q = Math.floor(start.getMonth() / 3);
    start.setMonth(q * 3, 1);
    return { from: ymd(start), to };
  }
  if (key === "year") {
    start.setMonth(0, 1);
    return { from: ymd(start), to };
  }
  return { from: ymd(start), to };
}

export const STATUS_LABEL: Record<string, string> = {
  tentative: "Tạm",
  "giữ chỗ tạm": "Giữ chỗ tạm",
  booked: "Đã đặt",
  contract: "Đã ký",
  shooting: "Đang chụp",
  editing: "Đang sửa",
  completed: "Hoàn tất",
  delivered: "Đã giao",
  cancelled: "Đã huỷ",
};

export function statusLabel(s: string | null | undefined): string {
  if (!s) return "—";
  return STATUS_LABEL[s] ?? s;
}
